import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const elementAnalysis = {
    jpath: ['spectra', 'elementalAnalysis'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default elementAnalysis;
//# sourceMappingURL=elementAnalysis.js.map